// removed by extract-text-webpack-plugin
module.exports = {"feature-label":"FeatureLabel__feature-label","featureLabel":"FeatureLabel__feature-label","icon":"FeatureLabel__icon","feature-icon":"FeatureLabel__feature-icon","featureIcon":"FeatureLabel__feature-icon","check-icon":"FeatureLabel__check-icon","checkIcon":"FeatureLabel__check-icon","feature-detail":"FeatureLabel__feature-detail","featureDetail":"FeatureLabel__feature-detail","text":"FeatureLabel__text","detail":"FeatureLabel__detail"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/FeatureList/components/FeatureLabel/FeatureLabel.css
// module id = 1334
// module chunks = 8